export default __webpack_public_path__ + "static/media/logo.f18fcfb2.svg";